namespace advisorop.domains {
    "use strict";

    export interface IAdvisorOpTable {
        id?: number;
        lId?: number;
        dateCreated?: Date;
        dateChanged?: Date;
        systemLoginIdCreated?: string;
        systemLoginIdChanged?: string;
        recordStatus?: RecordStatus;
        impersonatorId?: string;
    }
}